import { store } from '@operato/shell'
import setting from './reducers/setting'

export default function bootstrap() {
  store.addReducers({
    setting
  })
}
